module.exports = __webpack_public_path__ + "7fb3336c1339652fb1d95a5c808b5901.png";